import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
    html,
    body {
        width: 100%;
        min-height: 100%;
        margin: 0;
        padding: 0;
        background: ${({ theme }) => theme.colors.background};
        color: ${({ theme }) => theme.colors.text};
        font-family: 'Poppins', sans-serif;
    }

    #root {
        min-height: 100vh;
    }

    * {
        box-sizing: border-box;
    }

    button,
    input {
        font: inherit;
    }

    button {
        border: 0;
        background: transparent;
        color: inherit;
    }
`
